class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  // Moved all event listeners to a separate method for better organization
  attachEventListeners() {
    this.buttonClose = this.querySelector(".js-button-close");
    this.buttonClose.addEventListener("click", this.closeNewsletter.bind(this));

    if (this.form) {
      this.form.addEventListener("submit", this.onSubscribe.bind(this));
    }
  }

  init() {
    const configuredDelay = Number(this.dataset.delay || 0);
    this.delay = Number.isFinite(configuredDelay) ? Math.max(configuredDelay * 1000, 0) : 0;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.form = this.querySelector(".js-form");
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closeNewsletter() {
    setCookie("newsletter-closed", "true", 14);
    this.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
      this.show();
      }
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    // Do not interrupt the purchase journey on product pages.
    if (document.body.classList.contains("template--product")) return;

    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    let shown = false;
    const showWhenEligible = () => {
      if (shown || this.closed === "true" || this.subscribed === "true") return;
      shown = true;
      window.removeEventListener("scroll", handleEngagedScroll);
      this.show();
    };
    const handleEngagedScroll = () => {
      const scrollable = document.documentElement.scrollHeight - window.innerHeight;
      if (scrollable > 0 && window.scrollY / scrollable >= 0.5) showWhenEligible();
    };

    window.addEventListener("scroll", handleEngagedScroll, { passive: true });
    setTimeout(showWhenEligible, Math.max(this.delay, 30000));
  }

  onSubscribe() {
    setCookie("newsletter-subscribed", "true", 365);
    this.hide();
  }
}

customElements.define("newsletter-popup", NewsletterPopup);
